import React from 'react';
import { motion } from 'framer-motion';

const ProgressBar = ({ progress }) => {
  return (
    <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
      <motion.div
        initial={{ width: 0 }}
        animate={{ width: `${progress}%` }}
        transition={{ duration: 1, ease: "easeOut" }}
        className="h-full bg-gradient-to-r from-blue-500 to-orange-500 rounded-full"
        style={{
          background: progress === 100 
            ? 'linear-gradient(90deg, #10b981 0%, #059669 100%)'
            : 'linear-gradient(90deg, #2558ab 0%, #ff8057 100%)'
        }}
      />
    </div>
  );
};

export default ProgressBar;